import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { fuseAnimations } from '../../../core/animations';
import { MatPaginator } from '@angular/material/paginator';
import {fromEvent as observableFromEvent, Subscription} from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {MarketplaceService} from '../../../core/services/marketplace.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {FuseConfigService} from '../../../core/services/config.service';
import {OrganizationsService} from '../../../core/services/organizations.service';
import {MarketplaceCategoryService} from '../../../core/services/marketplaceCategory.service';

@Component({
  selector: 'app-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.scss'],
  animations: fuseAnimations,
  standalone: false
})
export class MarketplaceComponent implements OnInit, OnDestroy {
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public filterData: any = {};
  _pageIndex = 0;
  _perPage = 50;
  _search = '';
  _total = 0;

  marketplaces = [];
  type = '';
  status = '';
  category: any = [];
  countryId = '';
  cityId: any = [];
  organizationId: any = [];
  platformId = '';
  displayedColumns = ['date' , 'title' , 'author' , 'type' , 'status' ];
  marketplaceCategories = [];
  categoryInfo;
  private subscriptions =  new Subscription();

  constructor(public marketplaceService: MarketplaceService, private spinner: NgxSpinnerService,
              private fuseConfig: FuseConfigService, private organizationService: OrganizationsService,
              public marketplaceCategoryService: MarketplaceCategoryService) {
    this.subscriptions.add(this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        if (res.id !== this.platformId && this.platformId) {
          this.platformId = res.id;
          this.getMarketplaces();
        }
        this.platformId = res.id;
      }
    }));
  }
  ngOnInit() {
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          localStorage.setItem('matrixModulesSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScroll();
          this.getMarketplaces();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          localStorage.setItem('matrixModulesSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScroll();
          this.getMarketplaces();
        }
      });
    this.filterData.marketplaceType = true;
    this.filterData.marketplaceStatus = true;
    this.getCountries();
    this.getMarketplaceCategory();
  }

  getMarketplaceCategory() {
    this.marketplaceCategoryService.getMarketplaceCategory().subscribe((res: any) => {
      this.marketplaceCategories = res;
      this.checkCategories();
    });
  }

  getCountries () {
    this.organizationService.getCountry().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.countries = res;
        this.getMarketplaces();
      } else if (res.length === 1) {
        this.countryId = res[ 0 ].id;
        this.getCantons(res[ 0 ].id);
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getCantons (id) {
    this.organizationService.getCity(id).subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.cantons = res;
        this.getMarketplaces();
      } else if (res.length === 1) {
        this.cityId = res[ 0 ].id;
        this.getOrganizations();
        delete this.filterData.cantons;
      } else {
        delete this.filterData.cantons;
        this.getMarketplaces();
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getOrganizations () {
    this.marketplaceService.getOrganizationByCantonId(this.cityId).subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.organizations = res;
        this.getMarketplaces();
      } else if (res.length === 1) {
        this.organizationId = res[ 0 ].id;
        this.getMarketplaces();
        delete this.filterData.organizations;
      } else {
        delete this.filterData.organizations;
        this.getMarketplaces();
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  cleanScroll() {
    let table = document.getElementById('marketplacesPage');
    if (table) {
      table.scrollTop = 0;
      localStorage.setItem('marketplacesPage' , '0');
    }
  }

  getMarketplaces() {
    this.spinner.show();
    this.marketplaceService.getMarketplaces(this.type, this.organizationId, this.countryId, this.cityId,
      this.status, this.category, this._search, this._pageIndex, this._perPage, this.platformId).subscribe({
      next: data => {
        if (data) {
          this._total = data.total;
          this.marketplaces = data.marketplaces;
          this.categoryInfo = data.categories;
          this.checkCategories();
        }
        this.spinner.hide();
      },
      error: error => {
        this.spinner.hide();
      }
    });
  }

  checkCategories() {
    if (this.categoryInfo && this.marketplaceCategories?.length) {
      for (let i = 0; i < this.marketplaceCategories?.length; i++) {
        if (this.categoryInfo.hasOwnProperty(this.marketplaceCategories[i].id.toString())) {
          this.marketplaceCategories[i].total = this.categoryInfo[this.marketplaceCategories[i].id.toString()].total;
          this.marketplaceCategories[i].notActivated = this.categoryInfo[this.marketplaceCategories[i].id.toString()].notActivated;
        }
        for (let j = 0; j < this.marketplaceCategories[i].marketplaceSubcategory.length; j++) {
          if (this.categoryInfo.hasOwnProperty(this.marketplaceCategories[i].marketplaceSubcategory[j].id + '_sub')) {
            this.marketplaceCategories[i].marketplaceSubcategory[j].total = this.categoryInfo[this.marketplaceCategories[i].marketplaceSubcategory[j].id + '_sub'].total;
            this.marketplaceCategories[i].marketplaceSubcategory[j].notActivated =
              this.categoryInfo[this.marketplaceCategories[i].marketplaceSubcategory[j].id + '_sub'].notActivated;
          }
        }
      }
      console.log(this.marketplaceCategories);
      this.filterData.marketplaceCategories = this.marketplaceCategories;
    }
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    localStorage.setItem('eventPageIndex' , e.pageIndex);
    this.cleanScroll();
    this.getMarketplaces();
  }

  cleanAll() {
    this.marketplaces = [];
    this.type = '';
    this.status = '';
    this.category = [];
    this.countryId = '';
    this.cityId = [];
    this.organizationId = [];
    this.marketplaceCategories = [];
  }

  chooseFilters (e) {
    this.paginator.firstPage();
    this.cleanScroll();
    if (e.choose === 'all') {
      delete this.filterData.cantons;
      delete this.filterData.countries;
      delete this.filterData.organizations;
      delete this.filterData.marketplaceType;
      delete this.filterData.marketplaceStatus;
      delete this.filterData.marketplaceCategories;
      this.cleanAll();
      this.getMarketplaces();
      this.getCountries();
      setTimeout(() => {
        this.filterData.marketplaceType = true;
        this.filterData.marketplaceStatus = true;
        this.getMarketplaceCategory();
      }, 500);
    } else if (e.choose.hasOwnProperty('country')) {
      delete this.filterData.cantons;
      delete this.filterData.organizations;
      this.getCantons(e.choose.country);
      this.countryId = e.choose.country;
      for (let i = 0; i < this.filterData.countries.length; i++) {
        this.filterData.countries[i].selected = +this.filterData.countries[i].id === +e.choose.country;
      }
      this.getMarketplaces();
    } else if (e.choose.hasOwnProperty('canton')) {
      delete this.filterData.organizations;
      this.setCities(e.choose);
      this.getMarketplaces();
      this.getOrganizations();
    } else if (e.choose.hasOwnProperty('organization')) {
      this.setOrganizations(e.choose);
      this.getMarketplaces();
    } else if (e.choose.hasOwnProperty('marketplaceType')) {
      this.type = e.choose.marketplaceType;
      this.getMarketplaces();
    } else if (e.choose.hasOwnProperty('marketplaceStatus')) {
      this.status = e.choose.marketplaceStatus;
      this.getMarketplaces();
    } else if (e.choose.hasOwnProperty('marketplaceCategory')) {
      this.setCategory(e.choose);
      this.getMarketplaces();
    }
  }

  setCities (city) {
    if (city.selected) {
      this.cityId.push(city.canton);
    } else {
      const index = this.cityId.indexOf(city.canton);
      if (index !== -1) {
        this.cityId.splice(index , 1);
      }
    }
    const uniqueArr = new Set(this.cityId);
    this.cityId = [...uniqueArr];
  }

  setOrganizations (organization) {
    if (organization.selected) {
      this.organizationId.push(organization.organization);
    } else {
      const index = this.organizationId.indexOf(organization.organization);
      if (index !== -1) {
        this.organizationId.splice(index , 1);
      }
    }
    const uniqueArr = new Set(this.organizationId);
    this.organizationId = [...uniqueArr];
  }

  setCategory (category) {
    if (category.selected) {
      this.category.push(category.marketplaceCategory);
    } else {
      const index = this.category.indexOf(category.marketplaceCategory);
      if (index !== -1) {
        this.category.splice(index , 1);
      }
    }
    const uniqueArr = new Set(this.category);
    this.category = [...uniqueArr];
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
